module.exports = __webpack_public_path__ + "img/coach-exp-logo.47b36218.svg";